import { useQuery } from "@tanstack/react-query";
import { beneficiaryService } from "../../services/beneficiary.service";

const { getBeneficiaryPayerPlans } = beneficiaryService;

export const useGetBeneficiaryPayerPlans = (beneficiaryId: string) => {
	return useQuery({
		queryKey: ["beneficiary-payer-plans", beneficiaryId],
		queryFn: () => getBeneficiaryPayerPlans(beneficiaryId),
		enabled: !!beneficiaryId,
	});
};
